import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box } from "@mui/system";
import RemoveIcon from "@mui/icons-material/Remove";
import { Grid, TextField } from "@mui/material";
import styles from "./styles.css";
const DatepickerFilter = ({
  handleStart,
  handleEnd,
  valueStart,
  valueEnd,
  title,
  ...props
}) => {
  return (
    < >
      <p style={{ fontSize: '12px', marginBottom: '2px', color: '#2C4992', weight: '400', font: 'roboto' }}>{title}</p>
      <Grid item xs={"auto"}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            sx={{
              display: "flex",
              borderRadius: "1px",
              marginRight: "0.5rem",
              paddingTop: "5px",
              alignItems: "center",
              color: "#00a7e1",
              width: "fit-content"
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Início"
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => <TextField
                  size="medium"

                  {...params}{...props} />}
                value={valueStart}
                onChange={(value, newValue) => {
                  handleStart(new Date(value).toISOString().split('T')[0]);
                }}

              />
            </LocalizationProvider>
          </Box>
          <Box
            sx={{
              display: "flex",
              borderRadius: "1px",
              paddingTop: "5px",
              alignItems: "center",
              color: "#00a7e1",
              width: "fit-content"
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Fim"
                size="small"
                inputFormat="DD/MM/YYYY"

                slotProps={{
                  textField: { size: "small", color: "blueOcean" },
                }}
                renderInput={(params) => <TextField size="medium" {...params}{...props} />}

                value={valueEnd}
                onChange={(value, newValue) => {
                  handleEnd(new Date(value).toISOString().split('T')[0]);
                }}

              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default DatepickerFilter;
